import cn from 'classnames';
import React from 'react';
import {useEffect, useState} from 'react';

import Icon from './Icon';
import IqosLogoCollapsed from './IqosLogoCollapsed';

const IqosLogoAnimated = (props) => {
    const [offset, setOffset] = useState(0);
    const handleScroll = () => {
        setOffset(window.pageYOffset);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const SCROLL_ANIMATION_START = 5;
    const commonClasses = 'duration-700 transition-[transform] transition-[opacity] delay-[0ms]';
    const transitionClasses = cn(commonClasses, {'opacity-0': offset >= SCROLL_ANIMATION_START});

    return (
        <>
            <Icon width='88' height='32' viewBox='0 0 273 84' {...props}>
                <g
                    className={cn(transitionClasses, {
                        'translate-x-[35%]': offset >= SCROLL_ANIMATION_START,
                    })}
                >
                    <rect x='3.7' y='1' className='st0' width='8.9' height='83.1' fill='none' />
                    <path
                        className='st1'
                        d='M3.7,16v53c0,2.1,1.7,3.8,3.8,3.8c0,0,0,0,0,0h1.3c2.1,0,3.8-1.7,3.8-3.8V16c0-2.1-1.7-3.8-3.8-3.8H7.5
                            C5.4,12.2,3.7,13.9,3.7,16C3.7,16,3.7,16,3.7,16z'
                    />
                </g>

                <g
                    className={cn(transitionClasses, {
                        'translate-x-[-25%]': offset >= SCROLL_ANIMATION_START,
                    })}
                >
                    <rect x='197.1' y='1' className='st0' width='72.1' height='83.1' fill='none' />
                    <path
                        className='st1'
                        d='M220.5,12.2c-8.1,0-14,1.8-17.8,4.8c-3.6,2.8-5.7,7.1-5.6,11.6v1.9c-0.1,4.5,2,8.9,5.6,11.6
                            c3.8,3,9.7,4.8,17.8,4.8h25.3c2.5,0,4.9,0.2,7.3,0.8c1.8,0.4,3.5,1.1,5,2.2c0.7,0.5,1.3,1.3,1.6,2.1c0.4,1.1,0.6,2.3,0.5,3.4
                            c0.1,1.2-0.1,2.3-0.5,3.4c-0.3,0.8-0.9,1.6-1.7,2.1c-1.5,1.1-3.2,1.8-5,2.2c-2.4,0.5-4.9,0.8-7.3,0.8h-29.9
                            c-3.4,0-6.7-1.3-9.2-3.7l-1-1l-1-1c-1.5-1.5-4-1.4-5.4,0.1c0,0,0,0,0,0l-0.5,0.6l-0.4,0.5c-0.7,0.7-1,1.7-1,2.7c0,1,0.4,2,1.2,2.7
                            l1,1l1,1c2,1.9,4.4,3.5,7.1,4.5c2.6,1,5.4,1.6,8.2,1.6h30c8.2,0,14-1.8,17.8-4.8c3.6-2.8,5.7-7.1,5.6-11.6v-2
                            c0.1-4.5-2-8.9-5.6-11.6c-3.8-3-9.7-4.8-17.8-4.8h-25.4c-2.5,0-4.9-0.2-7.3-0.8c-1.8-0.4-3.5-1.1-5-2.2c-0.7-0.5-1.3-1.3-1.6-2.1
                            c-0.4-1.1-0.6-2.3-0.5-3.4c0-1.2,0.1-2.3,0.5-3.4c0.3-0.8,0.9-1.6,1.6-2.1c1.5-1.1,3.2-1.8,5-2.2c2.4-0.5,4.9-0.8,7.3-0.8h13.8
                            H248c3.3,0,6.5,1.2,8.9,3.4l1.3,1.1l1.3,1.1c0.8,0.7,1.7,1,2.8,1c1,0,2-0.5,2.6-1.3l0.4-0.5l0.4-0.5c1.4-1.6,1.3-4-0.3-5.4
                            c0,0,0,0,0,0l-1.3-1.3l-1.3-1.1c-4.1-3.7-9.4-5.7-14.9-5.7h-13.8L220.5,12.2z'
                    />
                </g>

                <g
                    className={cn(transitionClasses, {
                        'translate-x-[14%]': offset >= SCROLL_ANIMATION_START,
                    })}
                >
                    <rect x='22.2' y='1' className='st0' width='88' height='83.1' fill='none' />
                    <path
                        className='st1'
                        d='M98.1,65.6c-0.5-0.5-1.2-1-1.9-1.3c-0.7-0.3-1.5-0.4-2.2-0.5H49.6c-2.8,0-5.7-0.3-8.4-1.1
                            c-2.3-0.6-4.4-1.7-6.2-3.1c-1.2-1-2.2-2.3-2.9-3.7c-0.7-1.5-1-3-1-4.6v-29c0-0.7,0.6-1.3,1.2-1.3c0,0,0,0,0,0h41.4
                            c2.9,0,5.7,0.3,8.5,1.1c2.3,0.6,4.4,1.7,6.2,3.1c1.2,1,2.2,2.3,2.9,3.7c0.7,1.5,1,3,1,4.6v16.7c0,2.1,1.7,3.8,3.8,3.8h1.3
                            c2.1,0,3.8-1.7,3.8-3.8V33.7c0.1-5.9-2.5-11.4-7-15.2c-4.6-3.9-11.5-6.3-20.4-6.3H26c-2.1,0-3.8,1.7-3.8,3.8c0,0,0,0,0,0v35.4
                            c-0.1,5.9,2.5,11.4,7,15.2c4.6,3.9,11.5,6.3,20.4,6.3h41.8c0.4,0,0.8,0.1,1.2,0.2c0.4,0.2,0.7,0.4,1,0.7l4.6,4.6l4.6,4.6
                            c1.5,1.5,3.9,1.5,5.4,0c0,0,0,0,0,0l0.5-0.5l0.5-0.5c0.7-0.7,1.1-1.7,1.1-2.7c0-1-0.4-2-1.1-2.7l-5.5-5.5L98.1,65.6z'
                    />
                </g>

                <g
                    className={cn(transitionClasses, {
                        'translate-x-[14%]': offset >= SCROLL_ANIMATION_START,
                    })}
                >
                    <rect x='112.7' y='1' className='st0' width='79' height='83.1' fill='none' />
                    <path
                        className='st1'
                        d='M164.2,21.1c2.9,0,5.7,0.3,8.5,1.1c2.3,0.6,4.4,1.7,6.2,3.1c1.2,1,2.2,2.3,2.9,3.7c0.7,1.5,1,3,1,4.6v17.8
                            c0,1.6-0.3,3.2-1,4.6c-0.7,1.4-1.7,2.7-2.9,3.7c-1.8,1.5-3.9,2.5-6.2,3.1c-2.8,0.7-5.6,1.1-8.5,1.1h-24.1c-2.8,0-5.7-0.3-8.4-1.1
                            c-2.3-0.6-4.4-1.7-6.2-3.1c-1.2-1-2.2-2.3-2.9-3.7c-0.7-1.5-1-3-1-4.6V33.7c0-1.6,0.3-3.2,1-4.6c0.7-1.4,1.7-2.7,2.9-3.7
                            c1.8-1.5,4-2.5,6.2-3.1c2.8-0.7,5.6-1.1,8.5-1.1H164.2 M164.2,12.2h-24.1c-8.9,0-15.8,2.4-20.4,6.3c-4.5,3.7-7.1,9.3-7,15.2v17.8
                            c-0.1,5.9,2.5,11.4,7,15.2c4.6,3.9,11.5,6.3,20.4,6.3h24.2c8.9,0,15.8-2.4,20.4-6.3c4.5-3.7,7.1-9.3,7-15.2V33.7
                            c0.1-5.9-2.5-11.4-7-15.2C180,14.6,173.2,12.2,164.2,12.2'
                    />
                </g>
            </Icon>
            <IqosLogoCollapsed
                className={cn(commonClasses, 'absolute top-1/2 translate-y-[-50%] scale-75', {
                    'opacity-0': offset < SCROLL_ANIMATION_START,
                    'scale-100': offset >= SCROLL_ANIMATION_START,
                })}
            />
        </>
    );
};

export default IqosLogoAnimated;
